import { render, staticRenderFns } from "./UserData.vue?vue&type=template&id=19f95ddc&"
import script from "./UserData.vue?vue&type=script&lang=js&"
export * from "./UserData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports